import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ReceiptServiceService } from 'app/shared/receipt-dialog/receipt-service.service';
import { TellerGlobalServiceService } from 'app/shared/teller-data/teller-global-service.service';
import { DialogHelper } from 'app/core/utils/dialog-helper';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { Dates } from 'app/core/utils/dates';

@Component({
    selector: 'mifosx-teller-reports',
    templateUrl: './teller-reports.component.html',
    styleUrls: ['./teller-reports.component.scss']
})
export class TellerReportsComponent implements OnInit {
    selectedTeller: any;
    tellerReportsForm: FormGroup;
    reportTypeOptions = [
        { value: 'Caja_cashier_cash_journal', displayName: 'Journal Caja' },
        { value: 'Caja_teller_closure_final_report', displayName: 'Reporte De Cuadre' },
        { value: 'Caja_teller_and_vault_status_report', displayName: 'Estado De Efectivo'}
    ];

    constructor(private formBuilder: FormBuilder,
        private receiptService: ReceiptServiceService,
        private tellerGlobalService: TellerGlobalServiceService,
        private dialogHelper: DialogHelper,
        private matDialog: MatDialog,
        private router: Router,
        private route: ActivatedRoute,
        private dateUtils: Dates,
        ) { }

    ngOnInit(): void {
        this.tellerGlobalService.getSelectedTeller$().subscribe(data => this.selectedTeller = data);
        this.tellerReportsForm = this.formBuilder.group({
            'reportType': ['', Validators.required]
        });
    }

    onReportTypeChange(value: string) {
        this.receiptService.getReportParameterList(value).subscribe(data =>            
            this.addReportParameters(data)
        );
    }

    addReportParameters(parameterData: any) {          
        //Removes all report parameters
        this.tellerReportsForm.removeControl('asOn');
        
        const fields = parameterData['data'];               
        for (const f of fields) {           
            //console.log(f.row[1]);//parameter_variable
            //console.log(f.row[2]);//parameter_label
            //console.log(f.row[3]);//parameter_displayType            
            this.tellerReportsForm.addControl(f.row[1], new FormControl('', Validators.required));          
        }        
    }

    submit() {             
        let urlParams = {};
        if(this.tellerReportsForm.value.hasOwnProperty('asOn')){
            //urlParams['asOn'] = JSON.stringify(this.dateUtils.formatDate(this.tellerReportsForm.value.asOn, 'yyyy-MM-dd'));
            urlParams['asOn'] = this.dateUtils.formatDate(this.tellerReportsForm.value.asOn, 'yyyy-MM-dd');
        }

        this.receiptService.getTellerReport(this.selectedTeller['id'],this.tellerReportsForm.value.reportType,0, urlParams).subscribe(data => 
            this.dialogHelper.showDialog(data,this.matDialog,this.router,this.route));
    }

}
